// LPG tasarruf hesabı. Girdiler: L/100km, ₺/L benzin, ₺/L LPG, montaj maliyeti, aylık km.
export function calculateLPGSavings({
  fuelConsumption,
  fuelPrice,
  lpgPrice,
  installCost,
  monthlyKm,
  lpgExtraConsumption = 0.18, // LPG'de ~%18 daha yüksek hacimsel tüketim
}) {
  const litersPer100 = Number(fuelConsumption) || 0;
  const km = Number(monthlyKm) || 0;
  const monthlyPetrol = (litersPer100 / 100) * km * Number(fuelPrice);
  const monthlyLpg = (litersPer100 / 100) * (1 + lpgExtraConsumption) * km * Number(lpgPrice);
  const monthlySaving = monthlyPetrol - monthlyLpg;
  const paybackMonths = monthlySaving > 0 ? Number(installCost) / monthlySaving : Infinity;
  const yearlySaving = monthlySaving * 12;
  return {
    monthlyPetrol: Math.round(monthlyPetrol),
    monthlyLpg: Math.round(monthlyLpg),
    monthlySaving: Math.round(monthlySaving),
    yearlySaving: Math.round(yearlySaving),
    savingPercent: monthlyPetrol > 0 ? Math.round((monthlySaving / monthlyPetrol) * 100) : 0,
    paybackMonths: Number.isFinite(paybackMonths) ? Math.ceil(paybackMonths) : null,
    fiveYearNet: Math.round(yearlySaving * 5 - Number(installCost)),
  };
}

export const formatTL = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 0 }).format(n);
